import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import Media from 'components/Media';
import theme from '../theme';
import { mediaDesktop } from '../../breakpoints';

export const CollectedByWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding: 16px 0;

  border-radius: 16px;
  background-repeat: no-repeat;
  width: calc(100% - 48px);
  margin: 0 26px;

  ${mediaDesktop} {
    padding: 0 16px 16px;
    width: 100%;
    margin: 0 auto;
  }
`;

export const CollectedByBackground = styled(Media)`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  border-radius: 16px;
  z-index: 0;
  height: 100%;
  background-size: auto 160px;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));
  }

  ${mediaDesktop} {
    height: 432px;
    background-size: auto 432px;
  }
`;

export const CollectedByHead = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: self-start;
  padding: 16px;
  margin: 0;
  min-height: 144px;
  width: 100%;
  position: relative;

  ${mediaDesktop} {
    align-items: center;
    height: auto;
    flex-direction: column;
    max-width: 976px;
    padding: 0 145px 38px;
    margin: 0 auto 0px auto;
    width: 100%;
  }
`;

export const CollectedByCol = styled.div`
  position: relative;
  margin-right: 16px;
  z-index: 1;

  ${mediaDesktop} {
    margin-right: 0;
  }

  &:last-child {
    display: grid;
  }
`;

export const CollectedByAvatar = styled(Media)`
  display: block;
  width: 72px;
  height: 72px;
  border-radius: 72px;
  cursor: pointer;

  ${mediaDesktop} {
    margin-top: -60px;
    width: 120px;
    height: 120px;
    border-radius: 120px;
  }
`;

const titleStyles = css`
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #ffffff;
  cursor: pointer;
  text-decoration: none;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const CollectedByName = styled(Link)`
  font-family: ${theme.fonts.primary};
  font-size: 16px;
  letter-spacing: normal;
  ${titleStyles}

  ${mediaDesktop} {
    margin-top: 20px;
    font-size: 24px;
    text-align: center;
  }
`;

export const CollectedByTitle = styled(Link)`
  margin: 6px 0;
  font-family: ${theme.fonts.secondary};
  font-size: 24px;
  max-width: 100%;
  display: inline-block;
  ${titleStyles}

  ${mediaDesktop} {
    max-width: 576px;
    margin: 19px 0 5px;
    font-size: 72px;
    letter-spacing: normal;
    text-align: center;
  }
`;

export const CollectorTagWrapper = styled.div`
  text-align: center;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 7px;

  ${mediaDesktop} {
    flex-direction: row;
    justify-content: center;
    gap: 10px;
  }
`;
